<script>
  import { IconWand, IconCopy } from "@tabler/icons-svelte";
  import autosize from "svelte-autosize";
  import { copy } from "svelte-copy";

  export let result = "";
  let showCopiedText = false;

  $: {
    if (showCopiedText) {
      setTimeout(() => {
        showCopiedText = false;
      }, 1000);
    }
  }

  const handleCopyClick = () => {
    showCopiedText = true;
  };
</script>

<div class="form-field">
  <div class="form-field">
    <label class="block mt-0">
      <div for="text-completion-result" class="form-label">Result</div>
      <textarea
        id="text-completion-result"
        class="form-textarea"
        rows="3"
        bind:value={result}
        use:autosize
      ></textarea>
    </label>
  </div>
  <div class="grid gap-10 form-field">
    <button
      type="button"
      class="button button_wide"
      on:click={handleCopyClick}
      use:copy={result}
    >
      <IconCopy class="button__icon button__icon_left" />
      {#if showCopiedText}
        Copied!
      {:else}
        Copy
      {/if}
    </button>
    <button type="submit" class="button button_ghost button_wide">
      <IconWand class="button__icon button__icon_left" />
      Re-generate
    </button>
  </div>
</div>
